import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';

import waves from 'src/images/memory/waves.png';

import { Container } from './components';

const MemoryStepThreeExtraGroups = ({
  getGroups,
  hasLoaded,
  memoryStepThreeExtraCurrency,
  memoryStepThreeExtraGroups,
  student,
}) => {
  return (
    <Container
      cardBackgroundImage={waves}
      className="memory-groups-container--step-three-extra"
      collectionsPath={paths.MEMORY_STEP_THREE_EXTRA_COLLECTIONS}
      currency={memoryStepThreeExtraCurrency}
      getGroups={getGroups}
      hasLoaded={hasLoaded}
      items={memoryStepThreeExtraGroups}
      student={student}
    />
  );
};

MemoryStepThreeExtraGroups.propTypes = {
  getGroups: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  memoryStepThreeExtraCurrency: PropTypes.shape({}).isRequired,
  memoryStepThreeExtraGroups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  student: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.memoryStepThreeExtraGroups.getHasLoaded(state),
  memoryStepThreeExtraCurrency: selectors.memoryStepThreeExtraGroups.getCurrencyData(
    state
  ),
  memoryStepThreeExtraGroups: selectors.memoryStepThreeExtraGroups.getGroupsData(
    state
  ),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.memoryStepThreeExtra,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(MemoryStepThreeExtraGroups);
